import { useEffect, useRef, useContext } from "react";
import styled from "styled-components";
import Clock from "react-live-clock";
import { theme } from "./Theme";
import gsap from "gsap";
import { PortfolioContext } from "./AppContext";

const Hero = () => {
	const { setEnterHero } = useContext(PortfolioContext);
	const headerRef = useRef(null);
	const clockRef = useRef(null);

	useEffect(() => {
		const tl = gsap.timeline();

		tl.from(headerRef.current, {
			y: 500,
			opacity: 0,
			duration: 1.5,
			ease: "power3.out",
		})
			.to(headerRef.current, {
				scale: 1.2,
				duration: 0.6,
				ease: "power3.out",
			})

			.from(
				clockRef.current,
				{
					y: -30,
					opacity: 0,
					duration: 1,
					ease: "power3.out",
				},
				"-=1",
			);
	}, []);

	return (
		<div
			onMouseEnter={() => setEnterHero(true)}
			onMouseLeave={() => setEnterHero(false)}
		>
			<Content>
				<HeaderContainer>
					<PotfolioContainer ref={headerRef}>
						<h1>MAISON MAY</h1>
					</PotfolioContainer>
				</HeaderContainer>
				<ClockContainer ref={clockRef}>
					<div>
						<Clock format={"HH:mm"} ticking={true} timezone={"US/Eastern"} />{" "}
						EST
						<br /> MONT- <br />
						REAL
					</div>

					<p>IQRA IMRAN SYED</p>
					<p>CREATIVE DEVELOPER</p>
				</ClockContainer>
			</Content>
		</div>
	);
};

export default Hero;

const Content = styled.div`
	background-color: var(--v2);
	height: 100vh;
	width: 100vw;
	display: flex;
	will-change: transform;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
`;

const PotfolioContainer = styled.div`
	h1 {
		font-weight: 150px;
		font-family: "Darline serif";
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		/* img {
			height: 100px;
		} */
	}
`;

const ClockContainer = styled.div`
	color: var(--v4);
	height: auto;
	position: absolute;
	top: 0;
	left: 0;
	font-size: 14px;
	padding: 0.4rem 1rem;
	z-index: 1500;
	will-change: transform;
	line-height: 0.9;
	display: flex;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-weight: bold;
	margin: 10px 0;

	@media (max-width: ${theme.breakpoints.sm}) {
		font-size: 10px;
	}
`;
